import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=c8b4a528&scoped=true&lang=pug"
import script from "./txt.vue?vue&type=script&lang=js"
export * from "./txt.vue?vue&type=script&lang=js"
import style0 from "./txt.vue?vue&type=style&index=0&id=c8b4a528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b4a528",
  null
  
)

export default component.exports